module.exports = __webpack_public_path__ + "media/images/loading-8613a840fce8f5f097366f206c9719dd.gif";